import commaNumber from 'comma-number';
import { LineString, Point } from 'ol/geom';
import { Style, Stroke, Fill, Icon, Text } from 'ol/style';

import arrowIcon from '@/assets/vectors/arrow.svg';
import { convertProjectedRadiusToMeters, getDiameterLineCoordinates } from '@/utils/FenceUtil';
import { createDistanceLabelStyles } from '@/utils/PathUtils';
import { getCSSVariable } from '@/utils/theme';

export const MISSION_STYLES = {
  ARROW: (rotation) =>
    new Style({
      image: new Icon({ src: arrowIcon, rotation }),
    }),
  PATH: {
    LINE: new Style({
      stroke: new Stroke({ color: getCSSVariable('--tint-color'), width: 4 }),
    }),
    DISTANCE_LABEL: createDistanceLabelStyles,
  },
  FENCE: {
    CIRCLE: {
      OUTLINE: new Style({
        fill: new Fill({ color: [0, 0, 0, 0.3] }),
        stroke: new Stroke({ color: 'red', width: 2 }),
      }),
      DIAMETER_LINE: (geometry) => {
        const coordinates = getDiameterLineCoordinates(geometry);

        return new Style({
          geometry: new LineString(coordinates),
          stroke: new Stroke({
            color: 'red',
            width: 1,
            lineDash: [2, 4],
          }),
        });
      },
      DIAMETER_LABEL: (geometry) => {
        const diameter = convertProjectedRadiusToMeters(geometry) * 2;

        return new Style({
          geometry: new Point(geometry.getCenter()),
          text: new Text({
            text: `${commaNumber(diameter.toFixed(1))}m`,
            font: '12px "Noto Sans KR", sans-serif',
            fill: new Fill({ color: 'white' }),
            stroke: new Stroke({ color: 'black', width: 4 }),
          }),
        });
      },
    },
    POLYGON: {
      OUTLINE: new Style({
        fill: new Fill({ color: [0, 0, 0, 0.3] }),
        stroke: new Stroke({ color: 'red', width: 2 }),
      }),
    },
  },
};
